import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Social",
    children: /*#__PURE__*/_jsx("path", {
      d: "M26.45 2H5.55C3.61 2 2.03 3.57 2.03 5.52v14.01c0 1.94 1.57 3.52 3.52 3.52h2.58c.48 0 .87.39.87.87v5.16c0 .52.42.93.94.93.28 0 .53-.12.71-.32l5.52-6.35c.16-.18.39-.3.66-.3h9.64c1.94 0 3.52-1.57 3.52-3.52v-14c0-1.94-1.57-3.52-3.52-3.52Zm-4.33 8.75h-2.63v3.48h2.63c.48 0 .87.39.87.87v.04c0 .48-.39.86-.86.87H19.5v2.63a.87.87 0 0 1-1.74 0v-2.63h-3.5v2.63a.87.87 0 0 1-1.74 0v-2.63H9.88a.87.87 0 0 1 0-1.74h2.63v-3.5H9.88c-.48 0-.86-.38-.87-.86v-.02c0-.48.39-.87.87-.87h2.63V6.39a.87.87 0 0 1 1.74 0v2.63h3.48V6.39a.87.87 0 0 1 1.74 0v2.63h2.63c.48 0 .87.39.87.87v.02c0 .47-.37.85-.83.87Zm-7.86.01h3.48v3.48h-3.48z"
    })
  }));
};